"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mockedTwoBenefits = exports.mockedThreeBenefits = exports.mockedSixBenefits = exports.mockBenefitsNoData = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const mockBenefitsNoData = exports.mockBenefitsNoData = {
    __typename: 'EditorialBenefits'
};
const mockedThreeBenefits = exports.mockedThreeBenefits = {
    __typename: 'EditorialBenefits',
    id: 'benefits_12345',
    title: 'Why Choose Us',
    benefits: [
        {
            __typename: 'EditorialBenefit',
            caption: 'Reliable Solutions',
            icon: _editorialFetching.EditorialBenefitIcon.BubbleHeart,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'We offer top-notch services tailored to your needs.We offer top-notch services tailored to your needs.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Affordable Pricing',
            icon: _editorialFetching.EditorialBenefitIcon.Cashback,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Get the best services at the most affordable rates.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Aláh je bůh',
            icon: _editorialFetching.EditorialBenefitIcon.Gift,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Salám alejkum, vysočina lovečák ',
                    textLinks: []
                }
            ]
        }
    ]
};
const mockedTwoBenefits = exports.mockedTwoBenefits = {
    __typename: 'EditorialBenefits',
    id: 'benefits_12345',
    title: 'Why Choose Us',
    benefits: [
        {
            __typename: 'EditorialBenefit',
            caption: 'Reliable Solutions',
            icon: _editorialFetching.EditorialBenefitIcon.BubbleHeart,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'We offer top-notch services tailored to your needs.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Affordable Pricing',
            icon: _editorialFetching.EditorialBenefitIcon.Cashback,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Get the best services at the most affordable rates.',
                    textLinks: []
                }
            ]
        }
    ]
};
const mockedSixBenefits = exports.mockedSixBenefits = {
    __typename: 'EditorialBenefits',
    id: 'benefits_12345',
    title: 'Why Choose Us',
    benefits: [
        {
            __typename: 'EditorialBenefit',
            caption: 'Reliable Solutions',
            icon: _editorialFetching.EditorialBenefitIcon.BubbleHeart,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'We offer top-notch services tailored to your needs.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Affordable Pricing',
            icon: _editorialFetching.EditorialBenefitIcon.Cashback,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Get the best services at the most affordable rates.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Aláh je bůh',
            icon: _editorialFetching.EditorialBenefitIcon.Gift,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Salám alejkum, vysočina lovečák',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Reliable Solutions',
            icon: _editorialFetching.EditorialBenefitIcon.BubbleHeart,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'We offer top-notch services tailored to your needss.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Affordable Pricing',
            icon: _editorialFetching.EditorialBenefitIcon.Cashback,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Get the best services at the most affordable ratess.',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialBenefit',
            caption: 'Aláh je bůh',
            icon: _editorialFetching.EditorialBenefitIcon.Gift,
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Salám alejkum, vysočina lovečákk',
                    textLinks: []
                }
            ]
        }
    ]
};
